/**
 * Utility functions for vizCore bridge
 */

/**
 * Converts various sort order formats to ASC/DESC format
 * @param order Sort order in either ascending/descending or 1/-1 format
 * @returns Standardized sort direction ('ASC' or 'DESC')
 */
export const toSortDirection = order => {
  if (order === 'ascending' || order === -1) {
    return 'ASC';
  }
  return 'DESC';
};

/**
 * Converts various sort order formats to ascending/descending format
 * @param order Sort order in either ASC/DESC or 1/-1 format
 * @returns Standardized sort order ('ascending' or 'descending')
 */
export const toViewSortOrder = order => {
  if (order === 'ASC' || order === -1) {
    return 'ascending';
  }
  return 'descending';
};

/**
 * Converts numeric sort order format to ASC/DESC format
 * @param order Sort order in numeric format (1 = descending, -1 = ascending)
 * @returns Standardized sort direction ('ASC' or 'DESC')
 */
export const numericToSortDirection = order => {
  return order === -1 ? 'ASC' : 'DESC';
};

/**
 * Converts ASC/DESC format to numeric sort order format
 * @param direction Sort direction ('ASC' or 'DESC')
 * @returns Numeric sort order (-1 = ascending, 1 = descending)
 */
export const sortDirectionToNumeric = direction => {
  return direction === 'ASC' ? -1 : 1;
};